import { render, staticRenderFns } from "./PortfolioRankTag.vue?vue&type=template&id=f340f090"
import script from "./PortfolioRankTag.vue?vue&type=script&lang=js"
export * from "./PortfolioRankTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LeagueImg: require('/skade-pwa/components/ui/atom/LeagueImg.vue').default})
